$shm_tests_app_run $mol_page
	result null
	comparison_results /
	manifest_uri \
	display_title \
	title <= run_title \
	head /
		<= Title
		<= Header_controls $mol_view
			sub <= player_controls /$mol_view
	body <= body_rows /$mol_view
	Player $shm_tests_player
		result <= result
		comparison_results <= comparison_results
		manifest_uri <= manifest_uri
	Artifacts $mol_view
		sub /
			<= Artifacts_title $mol_view
				sub / \Артефакты
			<= Artifacts_list $mol_list
				rows <= artifact_rows /$mol_view
	Artifact* $mol_link
		uri <= artifact_uri* \
		external true
		sub /
			<= artifact_title* \
	Error $mol_text
		text <= error_text \
